import z from 'zod';

import type { EscrowSettingId } from '../BrandedIds';
import { zodBrandedUuid } from '../utils';
import { BaseLoanIdSideEffect } from './BaseLoanIdSideEffect';

export const GenerateMortgageInsuranceCancellationNoticeSideEffectContext = BaseLoanIdSideEffect.extend({
  escrowSettingId: zodBrandedUuid<EscrowSettingId>(),
});

export const GenerateMortgageInsuranceCancellationNoticeSideEffect =
  GenerateMortgageInsuranceCancellationNoticeSideEffectContext.extend({
    type: z.literal('generateMortgageInsuranceCancellationNotice'),
  });
export type GenerateMortgageInsuranceCancellationNoticeSideEffect = z.infer<
  typeof GenerateMortgageInsuranceCancellationNoticeSideEffect
>;
